[
    {
        "display": "true",
        "ui_columnname": "reportDate",
        "db_columnname": "reportDate",
        "datatype": "String",
        "mappingkey": "reportDate",
        "dropdown": "NO",
        "disabled": "true",
        "value": "",
        "dropdownvalue": "",
        "dropdowntype": "singleselect"
    },
    {
        "display": "true",
        "ui_columnname": "rsmsStatus",
        "db_columnname": "rsmsStatus",
        "datatype": "String",
        "mappingkey": "rsmsStatus",
        "dropdown": "NO",
        "disabled": "true",
        "value": "",
        "dropdownvalue": "",
        "dropdowntype": "singleselect"
    },
    {
        "display": "true",
        "ui_columnname": "groupName",
        "db_columnname": "groupName",
        "datatype": "String",
        "mappingkey": "groupName",
        "dropdown": "NO",
        "disabled": "true",
        "value": "",
        "dropdownvalue": "",
        "dropdowntype": "singleselect"
    },
    {
        "display": "true",
        "ui_columnname": "errorCodeList",
        "db_columnname": "errorCodeList",
        "datatype": "String",
        "mappingkey": "errorCodeList",
        "dropdown": "NO",
        "disabled": "true",
        "value": "",
        "dropdownvalue": "",
        "dropdowntype": "singleselect"
    },
    {
        "display": "true",
        "ui_columnname": "createDate",
        "db_columnname": "createDate",
        "datatype": "String",
        "mappingkey": "createDate",
        "dropdown": "NO",
        "disabled": "true",
        "value": "",
        "dropdownvalue": "",
        "dropdowntype": "singleselect"
    },
    {
        "display": "true",
        "ui_columnname": "updateDate",
        "db_columnname": "updateDate",
        "datatype": "String",
        "mappingkey": "updateDate",
        "dropdown": "NO",
        "disabled": "true",
        "value": "",
        "dropdownvalue": "",
        "dropdowntype": "singleselect"
    },
    {
        "display": "true",
        "ui_columnname": "lastUpdatedBy",
        "db_columnname": "lastUpdatedBy",
        "datatype": "String",
        "mappingkey": "lastUpdatedBy",
        "dropdown": "NO",
        "disabled": "true",
        "value": "",
        "dropdownvalue": "",
        "dropdowntype": "singleselect"
    },
    {
        "display": "true",
        "ui_columnname": "actionType",
        "db_columnname": "actionType",
        "datatype": "String",
        "mappingkey": "actionType",
        "dropdown": "NO",
        "disabled": "true",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "errorROEID",
        "db_columnname": "errorROEID",
        "datatype": "String",
        "mappingkey": "errorROEID",
        "dropdown": "NO",
        "disabled": "true",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "firmROEID",
        "db_columnname": "firmROEID",
        "datatype": "String",
        "mappingkey": "firmROEID",
        "dropdown": "NO",
        "disabled": "true",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "type",
        "db_columnname": "type",
        "datatype": "String",
        "mappingkey": "type",
        "dropdown": "NO",
        "disabled": "true",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "CATReporterIMID",
        "db_columnname": "CATReporterIMID",
        "datatype": "String",
        "mappingkey": "CATReporterIMID",
        "dropdown": "NO",
        "disabled": "true",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "allocationKeyDate",
        "db_columnname": "allocationKeyDate",
        "datatype": "String",
        "mappingkey": "allocationKeyDate",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "allocationID",
        "db_columnname": "allocationID",
        "datatype": "String",
        "mappingkey": "allocationID",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "optionID",
        "db_columnname": "optionID",
        "datatype": "String",
        "mappingkey": "optionID",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "eventTimestamp",
        "db_columnname": "eventTimestamp",
        "datatype": "String",
        "mappingkey": "eventTimestamp",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "cancelFlag",
        "db_columnname": "cancelFlag",
        "datatype": "Boolean",
        "mappingkey": "cancelFlag",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "cancelTimestamp",
        "db_columnname": "cancelTimestamp",
        "datatype": "String",
        "mappingkey": "cancelTimestamp",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "quantity",
        "db_columnname": "quantity",
        "datatype": "Float",
        "mappingkey": "quantity",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "price",
        "db_columnname": "price",
        "datatype": "Float",
        "mappingkey": "price",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "side",
        "db_columnname": "side",
        "datatype": "String",
        "mappingkey": "side",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "institutionFlag",
        "db_columnname": "institutionFlag",
        "datatype": "Boolean",
        "mappingkey": "institutionFlag",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "tradeDate",
        "db_columnname": "tradeDate",
        "datatype": "String",
        "mappingkey": "tradeDate",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "settlementDate",
        "db_columnname": "settlementDate",
        "datatype": "String",
        "mappingkey": "settlementDate",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "allocationType",
        "db_columnname": "allocationType",
        "datatype": "String",
        "mappingkey": "allocationType",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "DVPCustodianID",
        "db_columnname": "DVPCustodianID",
        "datatype": "String",
        "mappingkey": "DVPCustodianID",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "correspondentCRD",
        "db_columnname": "correspondentCRD",
        "datatype": "String",
        "mappingkey": "correspondentCRD",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "newOrderFDID",
        "db_columnname": "newOrderFDID",
        "datatype": "String",
        "mappingkey": "newOrderFDID",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "allocationInstructionTime",
        "db_columnname": "allocationInstructionTime",
        "datatype": "String",
        "mappingkey": "allocationInstructionTime",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "AccountHolderType",
        "db_columnname": "accountHolderType",
        "datatype": "String",
        "mappingkey": "accountHolderType",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "occClearingMemberID",
        "db_columnname": "occClearingMemberID",
        "datatype": "String",
        "mappingkey": "occClearingMemberID",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "firmDesignatedID",
        "db_columnname": "firmDesignatedID",
        "datatype": "String",
        "mappingkey": "firmDesignatedID",
        "dropdown": "NO",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    }
]